import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useTailNumberContext } from 'src/contexts/tail-number.context';
import { actionTypes } from 'src/ducks/tail-number.duck';
import { ITailNumber } from 'src/models/tail-number.model';
import Lang from 'src/libraries/language';
import { getTailNumberStatus } from 'src/selectors/tail-number.selector';
import style from '../tail-numbers-list/tail-numbers-list.module.scss';

type IProp = {
  data: ITailNumber;
};

const TailNumbersDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useTailNumberContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getTailNumberStatus(
    state,
    actionTypes.TAIL_NUMBER_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.tailId) {
      const response = await actions.itemDELETE(data.tailId);

      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(Lang.MSG_TAIL_DELETE_SUCCESS, data.tailNumber)
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_TAIL_NUMBER}
      content={
        <div className={style.content}>
          {Lang.formatString(
            data.Operators && data.Operators.length > 0
              ? Lang.MSG_CONFIRM_TAIL_OPERATOR_DELETE
              : Lang.MSG_CONFIRM_TAIL_DELETE,
            data.tailNumber
          )}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default TailNumbersDelete;
